<template>
  <div class="survey">
    <Component
      :is="componentsConfig[currentComponent]"
      @change-component="onChangeComponent"
    />
  </div>
</template>
<script setup>
import { useSurveyStore } from "~/nuxt_modules/survey/store/survey.store.js";
import { SURVEY_COMPONENT } from "~/nuxt_modules/survey/constants/index.js";

const props = defineProps({
  surveyId: { type: String, required: true },
});

const currentComponent = ref(SURVEY_COMPONENT.STEPS);

const surveyStore = useSurveyStore();

await surveyStore.fetchSurvey(props.surveyId);

const onChangeComponent = (component) => {
  currentComponent.value = component;
};

const componentsConfig = {
  [SURVEY_COMPONENT.STEPS]: defineAsyncComponent(
    () => import("./SurveyStep.vue"),
  ),
  [SURVEY_COMPONENT.FORM]: defineAsyncComponent(
    () => import("./SurveyForm.vue"),
  ),
};
</script>
<style scoped lang="scss">
.survey {
  width: 100%;
  min-height: 200px;

  @include flex-container(column, center, center);
}
</style>
